export default {"src":"/_next/static/media/Image.e67794ee.svg","height":70,"width":75,"blurWidth":0,"blurHeight":0};